<template lang="pug">
	.timeline-container
		analytics-opt-in
		timeline(
			v-if="liveticker && messages"
			:messages="messages",
			:order="liveticker.messages"
			:goal-sponsor="liveticker.goalSponsor"
			:goal-sponsor-link="liveticker.goalSponsorLink"
			:main-club="mainClub"
			:main-team-crest="mainTeamCrest"
			:opponent-team-crest="opponentTeamCrest"
		)

</template>

<script>
import AnalyticsOptIn from '@/components/AnalyticsOptIn'
export default {
	components: {
		AnalyticsOptIn
	},
	props: {
		liveticker: {
			type: Object,
			required: true
		},
		messages: {
			type: Array,
			required: true
		},
		mainTeamCrest: String,
		opponentTeamCrest: String
	},
	computed: {
		mainClub () {
			if (this.liveticker) {
				if (this.liveticker.home && this.liveticker.home.club && this.liveticker.home.club.isMain) {
					return this.liveticker.home.club._id
				} else if (this.liveticker.away && this.liveticker.away.club && this.liveticker.away.club.isMain) {
					return this.liveticker.away.club._id
				}
			}
			return '' // TODO: mainClub default value?
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
